<app-data-entry
  [dataEntry]="dataEntrySignal()"
  [fieldToFocus]="nextField() || null"
  (dataEntryRowChange)="onDataEntryRowChange($event)"
  (reasonsForChange)="onReasonsForChange($event)"
  (otherReasonForChange)="onOtherReasonChange($event)"
  (submitted)="onSubmitted($event)"
  (saveLater)="onSaveLater()"
></app-data-entry>
